export const TaskTypeInputs = [
  {
    id: 'vm',
    label: 'VM',
    value: 'vm',
    name: 'vm',
  },
  {
    id: 'downloadable-file',
    label: 'Downloadable file',
    value: 'downloadable',
    name: 'downloadable-file',
  },
  {
    id: 'our-material',
    label: 'Our material',
    value: 'THM',
    name: 'our-material',
  },
  {
    id: 'static-site',
    label: 'Static site',
    value: 'static-site',
    name: 'static-site',
  },
  {
    id: 'azure',
    label: 'Azure',
    value: 'azure',
    name: 'azure',
  },
  {
    id: 'none',
    label: 'None',
    value: 'none',
    name: 'none',
  },
];

export const TypeSelectLabel: Record<string, string> = {
  vm: 'Your VMs',
  downloadable: 'Your downloadable files',
  THM: 'Our material',
  'static-site': 'Static site',
  azure: 'Labs',
};
